var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { types } from './mutations';
import { container } from 'tsyringe';
import { JobListCreateEntity, JobListRepository } from 'packages/job_lists/JobListRepository';
var repository = container.resolve(JobListRepository);
export var actions = {
    listForCompany: function (_a) {
        var commit = _a.commit, rootGetters = _a.rootGetters;
        return __awaiter(this, void 0, void 0, function () {
            var items;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        commit(types.SET_LOADING, true);
                        return [4 /*yield*/, repository.listForCompany(rootGetters.currentCompanyId)];
                    case 1:
                        items = (_b.sent()).items;
                        commit(types.SET_JOB_LISTS, items);
                        commit(types.SET_LOADING, false);
                        return [2 /*return*/];
                }
            });
        });
    },
    getJobListSharingSettings: function (_a, id) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = commit;
                        _c = [types.SET_SHARING_SETTINGS];
                        return [4 /*yield*/, repository.getSharingSettings(id)];
                    case 1:
                        _b.apply(void 0, _c.concat([_d.sent()]));
                        return [2 /*return*/];
                }
            });
        });
    },
    saveJobListSharingSettings: function (_a, _b) {
        var commit = _a.commit, state = _a.state;
        var sharingSettings = _b.sharingSettings, id = _b.id;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, repository.saveJobListSharingSettings(id, sharingSettings)
                        .then()];
            });
        });
    },
    saveJobListAppearanceSettings: function (_a, _b) {
        var commit = _a.commit, state = _a.state;
        var appearance = _b.appearance, id = _b.id;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, repository.saveJobListAppearanceSettings(id, appearance)
                        .then()];
            });
        });
    },
    createJobList: function (_a, jobList) {
        var commit = _a.commit, state = _a.state;
        commit(types.SET_LOADING, true);
        commit(types.JOB_LIST_CREATE_API_ERROR, false);
        var createEntity = new JobListCreateEntity();
        Object.keys(jobList).forEach(function (k) { return createEntity[k] = jobList[k]; });
        return repository.createJobList(createEntity)
            .then(function (jobList) {
            commit(types.APPEND_JOB_LIST, jobList);
            return jobList;
        })
            .catch(function () { return commit(types.JOB_LIST_CREATE_API_ERROR, true); })
            .finally(function () { return commit(types.SET_LOADING, false); });
    },
    updateJobList: function (_a, jobList) {
        var commit = _a.commit, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var updatedJobList, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        commit(types.JOB_LIST_UPDATE_API_ERROR, false);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, repository.updateJobList(jobList.toSaveRequest())];
                    case 2:
                        updatedJobList = (_b.sent());
                        commit(types.UPDATE_JOB_LIST, updatedJobList);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _b.sent();
                        commit(types.JOB_LIST_UPDATE_API_ERROR, true);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    },
    createOrUpdateJobList: function (_a, payload) {
        var commit = _a.commit, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, repository.createOrUpdateJobList(payload.jobList, payload.companyId)];
            });
        });
    },
    publishJobList: function (_a, jobList) {
        var commit = _a.commit, dispatch = _a.dispatch;
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, repository.publish(jobList.id)];
                    case 1:
                        _b.sent();
                        jobList.published = true;
                        commit(types.UPDATE_JOB_LIST, jobList);
                        return [2 /*return*/];
                }
            });
        });
    },
    unpublishJobList: function (_a, jobList) {
        var commit = _a.commit, dispatch = _a.dispatch;
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, repository.unpublish(jobList.id)];
                    case 1:
                        _b.sent();
                        jobList.published = false;
                        commit(types.UPDATE_JOB_LIST, jobList);
                        return [2 /*return*/];
                }
            });
        });
    },
};
